import { defaultColor, stringToHSL, themeWrapper } from 'foundations/theme';
import React, { useEffect, useMemo, useState } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import history from '../../src/history';

export const IconVersion = 26;

const BodyStyles = createGlobalStyle`
    body {
        background: ${({ theme }) => `${theme.colors.ambience[24]} !important`};
    }
`;
const themeInfoSelector = (store) => store?.lounge?.airmeet?.theme_info;

const lightThemePageSelector = (store) => store?.genral?.isLightThemePage;
const isNewOnboardingPageSelector = (store) =>
    store?.genral?.isNewOnboardingPage;

export const ThemeContext = React.createContext(null);
export function AirmeetThemeProvider({ children }) {
    const query = new URLSearchParams(history.location.search);
    const lightThemeOverride = query.get('isLightAmbience') === 'true';
    const themeInfo = useSelector(themeInfoSelector);
    const isLightThemePage = useSelector(lightThemePageSelector);
    const isNewOnboardingPage = useSelector(isNewOnboardingPageSelector);

    const canApplyLightTheme = useMemo(() => {
        return isLightThemePage && (!isMobile || isTablet);
    }, [isLightThemePage]);

    const baseColor = useMemo(() => {
        if (canApplyLightTheme && themeInfo?.primary_color) {
            const values = stringToHSL(themeInfo?.primary_color);
            if (Array.isArray(values) && values.length >= 4) {
                return {
                    H: Number(values[1]),
                    S: Number(values[2]),
                    L: Number(values[3]),
                };
            }
        }
        return defaultColor;
    }, [canApplyLightTheme, themeInfo]);
    const isLightTheme = useMemo(
        () =>
            !!(
                (canApplyLightTheme && themeInfo?.is_light_theme) ||
                isNewOnboardingPage ||
                lightThemeOverride
            ),
        [canApplyLightTheme, themeInfo, isNewOnboardingPage, lightThemeOverride]
    );
    const [theme, setTheme] = useState(themeWrapper(baseColor, isLightTheme));

    useEffect(() => {
        setTheme(themeWrapper(baseColor, isLightTheme));
    }, [baseColor, isLightTheme]);

    useEffect(() => {
        // CDN path must be '/' for other JS files to load, for images we need to do this only
        const cdnUrl = process.env.CDN_ASSETS_URL;
        const svgPath = `${
            cdnUrl === '/' ? process.env.REACT_APP_BASE_URL + '/' : cdnUrl
        }images/icons.svg?v=${IconVersion}`;

        fetch(svgPath)
            .then((res) => res.text())
            .then((res) => {
                var div = document.createElement('div');
                div.style.display = 'none';
                div.innerHTML = res;
                document.body.insertBefore(div, document.body.childNodes[0]);
            });
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, isLightTheme, themeWrapper }}>
            <ThemeProvider theme={theme}>
                <BodyStyles />
                {children}
            </ThemeProvider>
        </ThemeContext.Provider>
    );
}
